export enum WorkingTimeSource {
  None = 'NONE',
  Assist = 'ASSIST',
  Gbox = 'GBOX',
}
